import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../authentication/session.service';
import { catchError, throwError } from 'rxjs';
import { NotificationService } from '../core/services/notification.service';

export const ErrorHandlingInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(SessionService);
  const notificationService = inject(NotificationService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse && err.status === 401) {
        session.logout();
        notificationService.error('Authentication required.');
      }
      return throwError(() => err);
    })
  );
};
